export default "__VITE_ASSET__B4rtO2lw__"